export default {
  // Title
  transfer: "Transfer",

  // Advanced Options
  advancedOpen: "Advanced >>",
  advancedClose: "Advanced <<",

  // Form Labels
  transferDirection: "Transfer Direction",
  transactionQuantity: "Transaction Quantity",
  currency: "Currency",
  occurrenceTime: "Occurrence Time",

  // Placeholders
  pleaseSelectTransferDirection: "Please select transfer direction",
  pleaseEnterCurrency: "Please enter currency",
  startDate: "Start Date",
  endDate: "End Date",

  // Transfer Direction Options
  inflow: "Inflow",
  outflow: "Outflow",
  bidirectional: "Bidirectional",

  // Buttons
  cancel: "Cancel",
  save: "Save",

  // Message Prompts
  saveSuccess: "Saved successfully",

  // Time Separator
  to: "to",
};
